import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import store from '../../../store';
import PropTypes from 'prop-types';
import iconLikeFb from '../../../iconfb/like.svg';
import iconCareFb from '../../../iconfb/care.svg';
import iconHahaFb from '../../../iconfb/haha.svg';
import iconAngryFb from '../../../iconfb/angry.svg';
import iconLoveFb from '../../../iconfb/love.svg';
import iconSadFb from '../../../iconfb/sad.svg';
import iconWowFb from '../../../iconfb/wow.svg';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { loadFBB, CheckCookie, DeleteCookie, updateFBBactive } from '../../../actions/FacebookbotActions';
import { deleteFbbot, updateActive, load, updateLimit, updateType } from '../../../actions/FbbotActions';
import Swal from 'sweetalert2';
import parse from 'html-react-parser';
import Modaledit from './modal_edit';
import Modalgiahan from './modal_giahan';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import Moment from 'react-moment';
import { RiExchangeDollarLine } from "react-icons/ri";
const { SearchBar } = Search;

class nhatky extends Component {
	static propTypes =  {
		loadFBB: PropTypes.func.isRequired,
		CheckCookie: PropTypes.func.isRequired,
		updateFBBactive: PropTypes.func.isRequired,
		deleteFbbot: PropTypes.func.isRequired,
		updateActive: PropTypes.func.isRequired,
		updateLimit: PropTypes.func.isRequired,
		updateType: PropTypes.func.isRequired,
	};
	
	state = {
		isOpenModalEdit: false,
		isOpenModalGiahan: false,
		id: 0,
		cookie: "",
		lnncx_type: [],
		idfb: 0,
	}
	
	componentDidMount() {
		// this.props.loadFBB();
	}
	
	onChangeLimit = e => {
		const { type } = this.props.Facebookbot;
		this.props.updateLimit('facebookbot', e.target.value);
		this.props.load('facebookbot', type, e.target.value);
	};
	
	onCheckList = (type) => {
		const { limit_pagi } = this.props.Facebookbot;
		this.props.updateType('facebookbot', type);
		this.props.load('facebookbot', type, limit_pagi);
	}
	
	huyOrder = (id, object_id) => {
		const swalWithBootstrapButtons = Swal.mixin({
			customClass: {
				confirmButton: 'btn btn-success an-margin-btn',
				cancelButton: 'btn btn-danger an-margin-btn'
				},
			buttonsStyling: false
		})

		swalWithBootstrapButtons.fire({
			title: 'HỦY LIKE ID: '+object_id+' ?',
			text: "Sau khi hủy bạn sẽ bị trừ 7 ngày chưa sử dụng và 5000 phí!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Đồng ý',
			cancelButtonText: 'Không',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				let body = {
					"id": id
				};
				this.props.upHuyOrder(body);
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				
			}
		})
	}
	
    openModalEdit = (data = null) => {
		this.setState({
			...this.state,
			isOpenModalEdit: !this.state.isOpenModalEdit,
		});
		if (data !== null) {
			this.setState({
				...this.state,
				isOpenModalEdit: !this.state.isOpenModalEdit,
				id: data.id,
				idfb: data.idfb,
				cookie: data.cookie,
				lnncx_type: data.likengaunhiencamxuc_type,
			});
		}
    }
    openModalGiahan = (data = null) => {
		this.setState({
			...this.state,
			isOpenModalGiahan: !this.state.isOpenModalGiahan,
		});
		if (data !== null) {
			this.setState({
				...this.state,
				isOpenModalGiahan: !this.state.isOpenModalGiahan,
				id: data.id,
				idfb: data.idfb,
				cookie: data.cookie,
				lnncx_type: data.likengaunhiencamxuc_type,
			});
		}
    }
	
	render() {
		const { listtientrinh, limit_pagi } = this.props.Facebookbot;
		const { username } = this.props.auth.user;
		var ar_listtientrinh = [];
		listtientrinh.forEach(function(v, i) {
			ar_listtientrinh.push(v);
		});
		function formatCheckCookie(cell, row) {
			if (cell === 1) {
				return parse("<span class='text-success'>Cookie live</span>");
			} else {
				return parse("<span class='text-danger'>Cookie die</span>");
			}
		}
		function filterValueCheckCookie(cell, row) {
			if (cell === 1) {
				return ("Cookie live");
			} else {
				return ("Cookie die</span>");
			}
		}
		
		function formatCheckTime(cell, row) {
			var result = new Date(row.created_at*1000);
			result.setDate(result.getDate() + parseInt(row.songaymua));
			var result_now = new Date();
			
			var difference = (result - result_now)/1000;
			if (difference >= 0) {
				// if (difference/86400 < 1) {
		          	// return Math.floor(difference/3600) + ' giờ';
		        // }
				const days = Math.floor(difference / 86400);
				const hours = Math.floor(difference / 3600) - (days * 24);
				const minutes = Math.floor(difference / 60) - (days * 24 * 60) - (hours * 60);
				const seconds = Math.floor(difference) - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
				var datediff = "";
				if (days > 0) {
					datediff += days + ' ngày ';
				}
				if (hours > 0) {
					datediff += hours + ' giờ ';
				}
				if (minutes > 0) {
					datediff += minutes + ' phút';
				}
				return datediff;
				{/* return (
					<Fragment>
						<Moment diff={result_now} unit="days">
								{result}
							</Moment>
						{' '} ngày
					</Fragment>
				); */}
			} else {
				return <span className="badge badge-danger">Hết hạn</span>;
			}
		}
		function filterValueCheckTime(cell, row) {
			var result = new Date(row.created_at*1000);
			result.setDate(result.getDate() + parseInt(row.songaymua));
			var result_now = new Date();
			
			var diffTime = (result - result_now)/1000;
			if (diffTime >= 0) {
				if (diffTime/86400 < 1) {
		          	return Math.floor(diffTime/3600) + ' giờ';
		        }
				var diffDays = Math.floor(diffTime / (60 * 60 * 24)) + ' ngày';
				return diffDays;
			} else {
				return ('Hết hạn');
			}
		}
		
		function formatFbName(cell, row) {
			return parse('<img src="https://graph.facebook.com/'+row.idfb+'/picture?height=100&amp;width=100" class="avatar-user"> '+row.usernamefb);
		}
		
		function formatCamXuc(cell, row) {
			var list_camxuc = '';
			if (row.likengaunhiencamxuc_type.indexOf("like") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconLikeFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("care") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconCareFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("love") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconLoveFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("haha") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconHahaFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("wow") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconWowFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("sad") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconSadFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			if (row.likengaunhiencamxuc_type.indexOf("angry") !== -1) {
				list_camxuc += '<label class="icon_feed_fb"><img src='+iconAngryFb+' alt="icon fb" class="img-responsive image-reaction ml-2 image-reaction-danhsach" /></label>';
			}
			return parse(list_camxuc);
		}
		
		function congcuBattat(cell, row) {
			var checkedzxc = '';
			if (row.active === 1) {
				checkedzxc = 'checked';
			}
			return (
				<Fragment>
					<div className="custom-control custom-switch mb-1">
						<input type="checkbox" className="custom-control-input" id={row.id} name={row.id} checked={checkedzxc} onChange={() => { store.dispatch(updateActive('facebookbot', row)) }} />
						<label className="custom-control-label" htmlFor={row.id}></label>
					</div>
				</Fragment>
			);
		}
		function formatTrangThai(cell, row) {
			var message = '';
			if (cell === 0) {
				return (
					<span className="badge badge-primary"><i className="fas fa-check mr-1"></i>Hoàn thành</span>
				);
			} else if (cell === 1) {
				return (
					<span className="badge badge-success"><i className="fas fa-sync-alt mr-1"></i>Đang chạy</span>
				);
			} else if (cell === 2) {
				return (
					<span className="badge badge-danger"><i className="fas fa-ban mr-1"></i>ID die không thể chạy</span>
				);
			} else if (cell === 3) {
				return (
					<span className="badge badge-warning"><i className="fas fa-times mr-1"></i>Hủy đơn</span>
				);
			} else if (cell === 5) {
				return (
					<span className="badge badge-info"><RiExchangeDollarLine size={12} className="mr-1" />Hoàn tiền</span>
				);
			} else {
				return ('');
			}
		}
		function filterValueTrangThai(cell, row) {
			if (cell === 0) {
				return ('Hoàn thành');
			} else if (cell === 1) {
				return ('Đang chạy');
			} else if (cell === 2) {
				return ('ID die không thể chạy');
			} else if (cell === 3) {
				return ('Hủy đơn');
			} else if (cell === 5) {
				return ('Hoàn tiền');
			} else {
				return ('');
			}
		}
		function formatBlocked(cell, row) {
			if (cell === 0) {
				return parse("<span class='text-success'>No</span>");
			} else {
				return parse("<span class='text-danger'>Block</span>");
			}
		}
		function filterValueBlocked(cell, row) {
			if (cell === 0) {
				return 'No';
			} else {
				return 'Block';
			}
		}
		function formatCheckTimeCreate(cell, row) {
			return (
				<Fragment>
					<Moment format="DD-MM-YYYY HH:mm:ss">{cell*1000}</Moment>
				</Fragment>
			);
		}
		function filterValueCheckTimeCreate(cell, row) {
			var d = new Date(cell*1000);
			var month = '' + (d.getMonth() + 1);
			var day = '' + d.getDate();
			var year = d.getFullYear();
			var hour = '' + (d.getHours());
			var min = '' + d.getMinutes();
			var sec = '' + d.getSeconds();

			if (month.length < 2)
				month = '0' + month;
			if (day.length < 2)
				day = '0' + day;
			if (hour.length < 2)
				hour = '0' + hour;
			if (min.length < 2)
				min = '0' + min;
			if (sec.length < 2)
				sec = '0' + sec;
			
			return [day, month, year].join('-') + ' ' + [hour, min, sec].join(':');
		}
		
		const columns = [{
			dataField: 'id',
			text: 'ID',
			sort: true,
		}, {
			dataField: 'idfb',
			text: 'ID Facebook',
			sort: true,
		}, {
			dataField: 'usernamefb',
			text: 'Name FB',
			sort: true,
			formatter: formatFbName,
		}, {
			dataField: 'check_cookie_live',
			text: 'Live',
			sort: true,
			formatter: formatCheckCookie,
			filterValue: filterValueCheckCookie
		}, {
			dataField: 'likengaunhiencamxuc_type',
			text: 'React',
			sort: true,
			formatter: formatCamXuc,
		}, {
			dataField: 'created_at',
			text: 'Time create',
			sort: true,
			formatter: formatCheckTimeCreate,
			filterValue: filterValueCheckTimeCreate
		}, {
			dataField: 'ngayconlai',
			text: 'Time Use',
			sort: true,
			formatter: formatCheckTime,
			filterValue: formatCheckTime
		}, {
			dataField: 'active',
			text: 'On/Off',
			sort: true,
			formatter: congcuBattat
		}, {
			dataField: 'username',
			text: 'User Add',
			sort: true,
		    classes: 'notranslate',
		}, {
			dataField: 'status',
			text: 'Status',
			sort: true,
			formatter: formatTrangThai,
			filterValue: filterValueTrangThai
		}, {
			dataField: '',
			text: 'Action',
			sort: true,
			formatter: (cell, row) => 
				<Fragment>
					{
						row.status !== 3 ?
							<Fragment>
								<a onClick={(e) => {e.preventDefault();this.openModalEdit(row)}} href="/#" className="btn btn-hero-primary text-center p-2 mr-1">
									<i className="fa fa-fw fa-pen"></i>
								</a>
								<a onClick={(e) => {e.preventDefault();this.openModalGiahan(row)}} href="/#" className="btn btn-hero-primary text-center p-2 mr-1">
									<i className="fa fa-fw fa-clock"></i>
								</a>
								<a onClick={(e) => {e.preventDefault();this.props.deleteFbbot('facebookbot', row.id)}} href="/#" className="btn btn-hero-danger text-center p-2 mr-1">
									<i className="fa fa-fw fa-trash"></i>
								</a>
							</Fragment>
						: ''
					}
				</Fragment>
		}];
		return (
			<Fragment>
				<ToolkitProvider keyField="id" data={ ar_listtientrinh } columns={ columns } search >
					{
						props => (
							<div>
								<SearchBar { ...props.searchProps } />
								<div className="row mb-4">
									<div className="col-md-12">
										{ this.props.auth.user.type === 1 ?
											<Fragment>
												<button onClick={() => {this.onCheckList(1)}} type="button" className="btn btn-primary mr-1">Xem tất cả</button>
												<button onClick={() => {this.onCheckList(0)}} type="button" className="btn btn-primary mr-1">Xem riêng</button>
											</Fragment>
										: ''}
										<select className="form-control custom-select select-light col-md-3 custom-limit_pagi" id="limit_pagi" name="limit_pagi" onChange={this.onChangeLimit} value={limit_pagi} >
											<option value="0">Số lịch sử hiển thị tối đa</option>
											<option value="50">50</option>
											<option value="100">100</option>
											<option value="200">200</option>
											<option value="500">500</option>
											<option value="1000">1000</option>
										</select>
									</div>
								</div>
								<BootstrapTable { ...props.baseProps } pagination={ paginationFactory() } wrapperClasses="table-responsive" striped hover condensed />
								{this.state.isOpenModalEdit ? <Modaledit openModal={this.openModalEdit} isOpenModal={this.state.isOpenModalEdit} dataid={this.state.id} datacookie={this.state.cookie} datalnncx_type={this.state.lnncx_type} dataidfb={this.state.idfb} /> : ''}
								{this.state.isOpenModalGiahan ? <Modalgiahan openModal={this.openModalGiahan} isOpenModal={this.state.isOpenModalGiahan} dataid={this.state.id} datacookie={this.state.cookie} datalnncx_type={this.state.lnncx_type} dataidfb={this.state.idfb} /> : ''}
							</div>
						)
					}
				</ToolkitProvider>
				<div>
					{/*<BootstrapTable keyField='id' data={ ar_listtientrinh } columns={ columns } pagination={ paginationFactory() } wrapperClasses="table-responsive" striped hover condensed />
					{this.state.isOpenModalEdit ? <Modaledit openModal={this.openModalEdit} isOpenModal={this.state.isOpenModalEdit} dataid={this.state.id} datacookie={this.state.cookie} /> : ''}*/}
				</div>
			</Fragment>
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	Facebookbot: state.Facebookbot,
});
const mapDispatchToProps = { loadFBB, CheckCookie, DeleteCookie, updateFBBactive, deleteFbbot, updateActive, load, updateLimit, updateType }

export default connect(mapStateToProps, mapDispatchToProps)(nhatky);